import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateExpedienteNotaRequest } from '@models/expedienteNota/createExpedienteNotaRequest.model';
import { ExpedienteNotaService } from '@services/expedienteNota/expedienteNota.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { FormExpedientePartesComponent } from '@views/expedientes/form-expediente-partes/form-expediente-partes.component';
import { ListRegistroContableComponent } from '@views/registros-contable/list-registro-contable/list-registro-contable.component';
import { Editor, NgxEditorModule } from 'ngx-editor';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { GeneralCalendarComponent } from '@component/general-calendar/general-calendar-list/general-calendar.component';
import { GoBackAndTitleComponent } from 'src/app/component/go-back-and-title/go-back-and-title.component';
import { ListExpedienteNotaComponent } from '../list-expediente-nota/list-expediente-nota.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';

import { ButtonAddComponent } from "../../../component/button-add/button-add.component";
import { ButtonCancelDialogComponent } from "../../../component/button-cancel-dialog/button-cancel-dialog.component";
import { UsuarioService } from '@services/usuario/usuario.service';
import { LoginService } from '@services/login/login.service';
import { AccionesDialog } from '@models/base/identificadores.model';

@Component({
  standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatTabsModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, CommonModule, FormsModule, MatSortModule, NgxSpinnerModule, FormsModule, ReactiveFormsModule, CommonModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, NgxEditorModule, ButtonCloseDialogComponent, ButtonAddComponent, ButtonAddComponent, ButtonCancelDialogComponent],
  selector: 'app-dialog-expediente-nota-create',
  templateUrl: './dialog-expediente-nota-create.component.html',
  styleUrls: ['./dialog-expediente-nota-create.component.css']
})
export class DialogExpedienteNotaCreateComponent {
  formBuilder: FormBuilder = new FormBuilder;
  form: any;
  editor!: Editor
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogExpedienteNotaCreateComponent>,
    private expedienteNotaService: ExpedienteNotaService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,

  ) { }
ngOnInit(){
  this.editor = new Editor();
  this.form = this.formBuilder.group({
    Descripcion: ['',Validators.compose([Validators.required])],

  });
}

ngOnDestroy(): void {
  this.editor.destroy();
}

onSubmit() {
  if (this.form.invalid) {
    return;
  }
  const createExpedienteNotaRequest: CreateExpedienteNotaRequest = new CreateExpedienteNotaRequest
  createExpedienteNotaRequest.descripcion = this.form.controls['Descripcion'].value == "" ? null : this.form.controls['Descripcion'].value;
  createExpedienteNotaRequest.idExpediente = this.data.idExpediente
  createExpedienteNotaRequest.idUsuario = this.loginService.getIdUser();
  this.spinner.show("spNota")
  this.expedienteNotaService.create(createExpedienteNotaRequest)
    .subscribe(
      data => {
        this.spinner.hide("spNota")
        this.snackBar.showSuccess("Se agrego el registro correctamente.", "Exito");
        this.dialogRef.close({event: AccionesDialog.Agregar, data:data});
      },
      error => {
        this.spinner.hide("spNota")
        this.snackBar.showError(error, "Error");
        this.dialogRef.close({event: AccionesDialog.Cancelar, data:null});
      })
}

}
